'use strict';

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _step = require('./step');

var _step2 = _interopRequireDefault(_step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stepper = function (_React$Component) {
  (0, _inherits3.default)(Stepper, _React$Component);

  function Stepper(props) {
    (0, _classCallCheck3.default)(this, Stepper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Stepper).call(this, props));

    _this.state = {
      activeStep: 1
    };
    _this.nextStep = _this.nextStep.bind(_this);
    _this.setStep = _this.setStep.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Stepper, [{
    key: 'getStepsCount',
    value: function getStepsCount() {
      return this.props.children && this.props.children[0] ? _react2.default.Children.count(this.props.children) : 0;
    }
  }, {
    key: 'getChildren',
    value: function getChildren() {
      var _this2 = this;

      var count = 0;
      var children = this.props.children;

      var state = this.state;
      return _react2.default.Children.map(children, function (step) {
        count++;

        var id = 'step-' + count; // TODO: make unique?
        var ref = id;
        var isActive = state.activeStep === count;
        var onNext = _this2.nextStep;
        var setStep = _this2.setStep;

        var isLastChild = false;

        if (count === _this2.getStepsCount()) {
          isLastChild = true;
        }

        return (0, _react.cloneElement)(step, {
          count: count,
          ref: ref,
          id: id,
          isActive: isActive,
          onNext: onNext,
          setStep: setStep,
          isLastChild: isLastChild
        });
      });
    }
  }, {
    key: 'setStep',
    value: function setStep(stepNumber) {
      this.setState({ activeStep: stepNumber });
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      var activeStep = this.state.activeStep;

      this.setState({ activeStep: activeStep + 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'ul',
        { className: 'mdl-stepper mdl-stepper--linear' },
        this.getChildren()
      );
    }
  }]);
  return Stepper;
}(_react2.default.Component);

Stepper.propTypes = {
  children: function children(props, propName) {
    var children = props[propName];
    _react2.default.Children.forEach(children, function (child) {
      if (child.type !== _step2.default) {
        throw new Error('Expected `Step` but found `' + (child.type.displayName || child.type) + '`');
      }
      return;
    });
  }
};

module.exports = Stepper;


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-stepper/dist/stepper.js
// module id = 829
// module chunks = 0